import $ from 'jquery';
import 'slick-carousel';

/**
 * Can be used only on places where jQuery is injected by the webpack otherwise versions will differ.
 * @var {object} config - Properties:
 *  {string} parent - jQuery selector for the wrapper of slider. (Needed in case filters are enabled)
 *  {string} slider - jQuery selector of the slider.
 *  {object} callbacks - Key pair of the event name and handler.
 *  {function} onload - The stuff need to be executed on initialization.
 *                      Not specified in the callbacks because of the possibility of reinitialization.
 *  {int} maxWidth - Window width after sliders disables.
 *  {int} minWidth - Window width before slider disables.
 */
export default ({ parent, slider, ...config }) => {
  const initiateSlider = ($slider) => {
    const { settings, callbacks, onload, minWidth = 0, maxWidth = Number.MAX_SAFE_INTEGER } = config;
    const setup = () => {
      $slider.slick(settings);
      if (callbacks) {
        $.each(callbacks, (event, callback) => $slider.on(event, callback));
      }
      if (onload) {
        onload($slider);
      }
    };

    if (minWidth + maxWidth !== Number.MAX_SAFE_INTEGER) {
      const $window = $(window);
      const decide = () => {
        const width = $window.innerWidth();

        if ($slider.hasClass('slick-initialized')) {
          if (width < minWidth || width > maxWidth) {
            $slider.slick('unslick');
          }
        } else if (width >= minWidth && width <= maxWidth) {
          setup();
        }
      };

      $window.resize(decide);
      $(decide);
    } else {
      setup();
    }
  };

  if (parent) {
    $(parent).each(function () {
      const $parent = $(this);
      const $slider = $parent.find(slider);

      if ($slider.length) {
        initiateSlider($slider);
        $parent
          .find('[data-filter]')
          .on('click', function () {
            const $filter = $(this);
            const filter = $filter.data('filter');

            // Handling filters UI
            $filter.addClass('active').siblings().removeClass('active');

            // Filtering
            $slider.slick('slickUnfilter');
            if (filter) {
              $slider.slick('slickFilter', `.${filter}`);
            } else {
              $slider.slick('refresh');
            }
          });
      }
    });
  } else {
    $(slider).each((i, e) => initiateSlider($(e)));
  }
};



// WEBPACK FOOTER //
// ./vively/scripts/utils/slider-loader.js